import Layout from "../../Internal/Layout.vue";
import NewsFeed from "./newsFeed.vue";

const NewsFeedRoutes = {
  component: Layout,
  children: [
    {
      path: "/feed-noticias",
      name: "NewsFeed",
      component: NewsFeed,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresResale: true,
      },
    },
  ],
};

export default NewsFeedRoutes;
